import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, toast } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
import {
// TRANSACTION_STATUSES_NAMES,
FEE_TYPES, TRANSACTION_TYPES } from 'src/constants/payments';
export default function TransactionMenu(_ref) {
  let _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    transaction = _ref.transaction;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    refundItemClicked = _useState4[0],
    setRefundItemClicked = _useState4[1];
  const open = Boolean(anchorEl);
  const getAvaliableRefund = async () => {
    const resp = await store.transaction.getAvaliableRefundAsync.run({
      transactionId: store.transaction.transactionId
    });
    return resp;
  };
  useEffect(() => {
    if (refundItemClicked) {
      getAvaliableRefund().then(() => {
        if (store.transaction.availableRefundAmount === 0) {
          toast('warning', {
            body: ['No refund available for this payment']
          }); // ? i18n
          store.transaction.setTransactionId('');
          store.transaction.setVoidTransactionType('');
          return;
        }
        store.transaction.setRefundModalIsOpen(true);
        setRefundItemClicked(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refundItemClicked]);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClick = _ref2 => {
    let menuType = _ref2.menuType;
    handleClose();
    switch (menuType) {
      case TRANSACTION_TYPES.Void:
        {
          var _transaction$metadata, _transaction$metadata2;
          store.transaction.setRefundType(TRANSACTION_TYPES.Void);
          store.transaction.setTransactionId(id);
          store.transaction.setRefundModalIsOpen(true);
          store.transaction.setVoidTransactionType((transaction === null || transaction === void 0 ? void 0 : transaction.transactionType) === 'UtilityCharge' && transaction !== null && transaction !== void 0 && (_transaction$metadata = transaction.metadata) !== null && _transaction$metadata !== void 0 && _transaction$metadata.amountBeforeUtilityCap ? 'CAPPED_UTILITY_CHARGE' : (transaction === null || transaction === void 0 ? void 0 : transaction.transactionType) === 'StatementCapCredit' ? 'STATEMENT_CAP_CREDIT' : (transaction === null || transaction === void 0 || (_transaction$metadata2 = transaction.metadata) === null || _transaction$metadata2 === void 0 ? void 0 : _transaction$metadata2.feeType) === FEE_TYPES.AccountSetup ? 'ACCOUNT_SETUP_FEE' : '');
          return;
        }
      case TRANSACTION_TYPES.Refund:
        {
          store.transaction.setRefundType(TRANSACTION_TYPES.Refund);
          store.transaction.setTransactionId(id);
          setRefundItemClicked(true);
          store.transaction.setRefundModalIsOpen(true);
          return;
        }
    }
  };
  const OptionsList = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!(transaction !== null && transaction !== void 0 && transaction.canRefund) && /*#__PURE__*/React.createElement(Button, {
      onClick: event => handleMenuClick({
        event,
        menuType: TRANSACTION_TYPES.Refund
      }),
      variant: "menuAction",
      disabled: !(transaction !== null && transaction !== void 0 && transaction.canRefund),
      'custom-attribute': '464-transaction-menu'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "logout-circle"
    }), t('resident_account.process_refund')), !!(transaction !== null && transaction !== void 0 && transaction.canPmVoid) && /*#__PURE__*/React.createElement(Button, {
      disabled: !(transaction !== null && transaction !== void 0 && transaction.canPmVoid),
      onClick: event => handleMenuClick({
        event,
        menuType: TRANSACTION_TYPES.Void
      }),
      variant: "menuAction",
      'custom-attribute': '465-transaction-menu'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "minus-circle"
    }), t('resident_account.void_this_charge')));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": "action-menu",
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "resident menu",
    className: classes.transactionDropdown,
    disabled: !(transaction !== null && transaction !== void 0 && transaction.canPmVoid) && !(transaction !== null && transaction !== void 0 && transaction.canRefund),
    id: "action-menu-trigger",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    variant: "actionButton",
    'custom-attribute': '466-transaction-menu'
  }, /*#__PURE__*/React.createElement("span", null, t('resident_account.options')), /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    elevation: 0,
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    onClose: handleClose,
    open: open,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    type: "action-menu"
  }, /*#__PURE__*/React.createElement(OptionsList, null)));
}
TransactionMenu.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string
};